var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudio = function SvgAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.252 1.002A1 1 0 0 0 6.73.148L3.304 2.242a.04.04 0 0 0-.021.038c0 .024-.02.044-.044.044H1a1 1 0 0 0-1 1v5.453a1 1 0 0 0 1 1h2.239c.024 0 .044.02.044.044q0 .025.021.038l3.426 2.094a1 1 0 0 0 1.522-.853z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M10.995 10.15a6.39 6.39 0 0 0 0-9.035"
  })));
};
export default SvgAudio;